import { render } from "./tableModule.vue?vue&type=template&id=345576be&scoped=true"
import script from "./tableModule.vue?vue&type=script&lang=js"
export * from "./tableModule.vue?vue&type=script&lang=js"

import "./tableModule.vue?vue&type=style&index=0&id=345576be&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-345576be"]])

export default __exports__